<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Services'}">
              <h4 class="ms-2">
                {{label.router.Service}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row class="tab-content">
            <b-col cols="6" class="py-0">
              <b-row class="my-4" v-show="contentLanguageAccess == 1">
                <b-col class="align-self-center" cols="4">
                  <label for="language" class="ps_label">
                    {{label.pages.contentLanguage}}
                    <span class="ps_label_sdtar">*</span>
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <v-select
                      input-id="language"
                      :options="languages"
                      v-model="selectedLanguage"
                      :reduce="group => group.id"
                      size="sm"
                      :clearable="false"
                      class="ps_select"
                  >
                  </v-select>
                </b-col>
              </b-row>
              <b-row class="my-4">
                <b-col class="align-self-center" cols="4">
                  <label for="title" class="ps_label">
                    {{label.pages.title}}
                    <span class="ps_label_star">*</span>
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="8">
                  <b-form-input id="title" size="md" v-model="form.title"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row v-if="dropZoneAction" class="my-4">
                <b-col>
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!dropZoneAction" class="my-4">
                <b-col sm="12">
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="10">
              <b-row class="my-4">
                <b-col cols="2">
                  <label for="shortDescription" class="ps_label">
                    {{label.pages.summary}}
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="me-1 mouse-question"
                        id="serviceShortDescGuide"
                    />
                    <b-popover
                      boundary="#app"
                      placement="top"
                      noninteractive
                      triggers="hover"
                      target="serviceShortDescGuide"
                      dir="rtl"
                    >
                      {{ label.pages.Description }}
                    </b-popover>
                  </label>
                </b-col>
                <b-col cols="10">
                  <b-form-textarea
                    id="shortDescription"
                    size="sm"
                    rows="2"
                    v-model="form.description"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="2">
              <b-row class="my-4">
                <b-col class="text-start">
                  <label for="Display" class="ps_label">
                    {{label.form.display}}
                  </label>
                </b-col>
                <b-col>
                  <label class="ps-switch">
                    <input id="Display" type="checkbox" v-model="form.isConfirm">
                    <span class="slider round"></span>
                  </label>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <label for="content" class="ps_label">
                    {{label.form.description}}
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="me-1 mouse-question"
                        id="serviceDescGuide"
                    />
                    <b-popover
                      boundary="#app"
                      placement="top"
                      noninteractive
                      triggers="hover"
                      target="serviceDescGuide"
                      dir="rtl"
                    >
                      {{ label.guide.serviceDesc }}
                    </b-popover>
                  </label>
                  <DxHtmlEditor v-model="form.text" :height="editorHeight" >
                    <DxMediaResizing :enabled="mediaResize" />
                    <DxImageUpload
                            :tabs="imageUploadType"
                            :file-upload-mode="imageUploadMode"
                    />
                    <DxToolbar :multiline="multilineToolbar">
                      <DxItem :accepted-values="headerValues" name="header" />
                      <DxItem :accepted-values="sizeValues" name="size" />
                      <DxItem :accepted-values="fontValues" name="font" />
                      <DxItem name="separator" />
                      <DxItem
                              v-for="toolbar in editorToolbar"
                              :key="toolbar.id"
                              :name="toolbar.name"
                      />
                    </DxToolbar>
                  </DxHtmlEditor>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-body>
      <template #footer>
        <div class="d-flex justify-content-end">
          <button
              @click="$router.go(-1)"
              class="ms-2"
              v-b-tooltip.hover
              :title="label.buttons.back"
          >
            <b-icon
                icon="arrow-right-square-fill"
                scale="2.5"
                class="pt-1"
                variant="ps-secondary-icon"
            >
            </b-icon>
          </button>
          <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addService"
          >
            <b-icon icon="check2-circle" class="ms-1"/>
            {{label.buttons.recordInfo}}
          </b-button>
          <b-button
              v-else
              disabled
              variant="ps-success"
              size="sm"
              class="mx-1"
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import dropZoneCustom from '@/components/DropZoneCustom'
import { devExtremeEditor } from "@/components/textEditor/devExtremeEditor";
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "AddService",
  mixins: [devExtremeEditor, contentLanguage],

  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
    }),
  },
  components: {
    dropZoneCustom
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.$router.push({name: 'Services'})
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.imageName = this.imageUrl[0].fullPath
        this.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  data() {
    return {
      label,
      refreshImage: true,
      dropZoneAction: true,
      imageName: null,
      imageAddress: null,
      form: {
        title: null,
        description: null,
        text: '',
        isConfirm: true,
      }
    }
  },
  methods: {
    handleImageUpload(file) {
      this.file = file;
    },
    addService() {
      this.$store.commit("setLoadingBtn", true);
      if(this.form.title && this.form.title != '') {
        let formData = new FormData();
        if (this.form.title) {
          formData.append('Title', this.form.title);
        }
        if (this.form.text) {
          formData.append('Text', this.form.text);
        }
        if (this.form.description) {
          formData.append('ShortDescription', this.form.description);
        }
        if (this.imageName) {
          formData.append('ImageName', this.imageName);
        }
        formData.append('IsConfirm', this.form.isConfirm);
        formData.append('languageId', this.selectedLanguage);
        this.$store.dispatch('baseX/addService', formData);
      } else {
        this.$store.commit('setError', alert.error.empty)
      }
      this.$store.commit("setLoadingBtn", false);
    },
  },
  mounted() {
    this.dropZoneAction = true;
    this.$store.commit("setUrlsEmpty");
  }
}
</script>
